'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paths = require('./paths');

var _middleware = require('../../middleware');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (sid, fid) {
  return function (dispatch) {

    return dispatch(_defineProperty({
      sid: sid,
      fid: fid

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.schoolCompetitorsUrl)(sid, fid)
      },
      types: ['GET_STUDENTS_START', 'GET_STUDENTS', 'GET_STUDENTS_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/schools/getCompetitorsForSchool.js
// module id = 668
// module chunks = 0